@if(isLoading())
{
<div class="d-flex flex-column align-items-center justify-content-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">Indlæser fejllog...</h4>
</div>
}
@else
{
<div class="card card-no-border h-100 vh-80">
    <div class="d-flex flex-column card-body no-padding">
        <!-- The tab label on the admin dashboard is the title. -->
        <div class="flex-grow-1 row" style="height: calc(100vh - 300px);">
            <!-- Left panel - Error list -->
            <div class="col-4 d-flex flex-column h-100">
                <div class="card h-100 d-flex flex-column">
                    <div class="card-header flex-shrink-0">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Fejllog</h5>
                            <div class="d-flex align-items-center gap-2">
                                <div ngbDropdown class="d-inline-block" style="width: 250px;">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle w-100 d-flex justify-content-between align-items-center" ngbDropdownToggle>
                                        <span class="text-truncate">{{ customerFilterLabel() }}</span>
                                    </button>
                                    <div ngbDropdownMenu style="min-width: 300px; max-height: 400px; overflow-y: auto;">
                                        <button ngbDropdownItem (click)="setCustomerFilter(null)"
                                                [class.active]="customerFilter() === null">
                                            Alle kunder
                                        </button>
                                        @for (customer of availableCustomers(); track customer.customerId) {
                                        <button ngbDropdownItem (click)="setCustomerFilter(customer.customerId)"
                                                [class.active]="customerFilter() === customer.customerId">
                                            {{ customer.customerName }} [{{ customer.customerId }}]
                                        </button>
                                        }
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-primary" (click)="errorsResource.reload()" 
                                        ngbTooltip="Genindlæs">
                                    <i class="fa-solid fa-arrow-rotate-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-header flex-shrink-0 d-flex flex-column">
                        <!-- Search bar -->
                        <div class="mb-2">
                            <app-search-input 
                                [(searchText)]="searchText"
                                [searchFields]="['customerName', 'stacktrace', 'requestObject', 'logId']"
                                [placeholder]="'Søg i fejllog...'"
                                [items]="customerFilteredErrors()"
                                (filteredItemsChange)="onFilteredErrorsChange($event)">
                            </app-search-input>
                        </div>
                        
                        <!-- Time filter -->
                        <div class="mb-2">
                            <small class="text-muted">Hent service fejl logs siden...</small>
                            <div class="btn-group btn-group-sm w-100 mt-1" role="group">
                                <button type="button" class="btn time-filter-30d"
                                        [class.active]="timeFilter() === '30d'"
                                        (click)="setTimeFilter('30d')">
                                    Sidste 30 dage ({{ thirtyDayCount() }})
                                </button>
                                <button type="button" class="btn time-filter-7d"
                                        [class.active]="timeFilter() === '7d'"
                                        (click)="setTimeFilter('7d')">
                                    Sidste 7 dage ({{ sevenDayCount() }})
                                </button>
                                <button type="button" class="btn time-filter-24h"
                                        [class.active]="timeFilter() === '24h'"
                                        (click)="setTimeFilter('24h')">
                                    Sidste 24 timer ({{ twentyFourHourCount() }})
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Error list -->
                    <div class="card-body flex-grow-1 p-0" style="overflow-y: auto;">
                        @if(filteredErrors().length === 0) {
                        <div class="p-3 text-center text-muted">
                            Ingen fejl at vise
                        </div>
                        }
                        @else {
                        <div class="list-group list-group-flush">
                            @for (error of filteredErrors(); track error.logId) {
                            <button type="button" 
                                    class="list-group-item list-group-item-action queue-item"
                                    [class.active]="selectedErrorId() === error.logId"
                                    (click)="selectError(error)">
                                <div class="d-flex w-100 justify-content-between">
                                    <h6 class="mb-1">
                                        {{ error.customerName || 'Ukendt kunde' }}
                                        <small class="text-muted">[{{ error.kundeId }}]</small>
                                    </h6>
                                    <small>{{ error.timestamp | date:'dd-MM-yyyy HH:mm' }}</small>
                                </div>
                                <p class="mb-1 text-truncate">
                                    <small>{{ truncateText(error.stacktrace, 80) }}</small>
                                </p>
                                @if(error.requestObject) {
                                <p class="mb-0 text-truncate">
                                    <small class="text-muted">{{ truncateText(error.requestObject, 60) }}</small>
                                </p>
                                }
                            </button>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Right panel - Error details -->
            <div class="col-8 d-flex flex-column h-100">
                <div class="card h-100 d-flex flex-column">
                    @if(!selectedError()) {
                    <div class="card-body d-flex align-items-center justify-content-center">
                        <div class="text-center text-muted">
                            <i class="fa-solid fa-circle-info fa-3x mb-3"></i>
                            <p>Vælg en fejl fra listen for at se detaljer</p>
                        </div>
                    </div>
                    }
                    @else {
                    <div class="card-header flex-shrink-0">
                        <div class="d-flex flex-column">
                            <h5 class="mb-0">Fejldetaljer</h5>
                            <div class="mt-1">
                                <small class="text-muted">
                                    <strong>Kunde:</strong> {{ selectedError()!.customerName || 'Ukendt' }} [{{ selectedError()!.kundeId }}]
                                    <span class="ms-2">| {{ selectedError()!.timestamp | date:'dd-MM-yyyy HH:mm:ss' }}</span>
                                </small>
                            </div>
                            <div class="mt-1">
                                <small class="text-muted">
                                    <strong>Log ID:</strong> {{ selectedError()!.logId }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-3 flex-grow-1 overflow-auto">
                        <!-- Stacktrace -->
                        <div class="mb-4">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <label class="fw-bold mb-0">Stacktrace:</label>
                                <button class="btn btn-sm btn-outline-secondary" 
                                        (click)="copyToClipboard(selectedError()!.stacktrace, 'Stacktrace')"
                                        ngbTooltip="Kopiér stacktrace">
                                    <i class="fa-regular fa-copy"></i> Kopiér
                                </button>
                            </div>
                            <textarea class="form-control font-monospace" 
                                      rows="15" 
                                      readonly
                                      [value]="selectedError()!.stacktrace"></textarea>
                        </div>

                        <!-- Request Object -->
                        @if(selectedError()!.requestObject) {
                        <div class="mb-3">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <label class="fw-bold mb-0">Request Object:</label>
                                <button class="btn btn-sm btn-outline-secondary" 
                                        (click)="copyToClipboard(selectedError()!.requestObject!, 'Request Object')"
                                        ngbTooltip="Kopiér request object">
                                    <i class="fa-regular fa-copy"></i> Kopiér
                                </button>
                            </div>
                            <textarea class="form-control font-monospace" 
                                      rows="10" 
                                      readonly
                                      [value]="selectedError()!.requestObject"></textarea>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
}
